import React from "react";
import './ListingLoader.scss';
 
const ListingLoader = props => {
  return (
    <ul className="listing-loader-container">
     
      <li>
        <span className="line line1"></span>
        <span className="line small-line"></span>
      </li>
      <li>
        <span className="line line1"></span>
        <span className="line small-line"></span>
      </li>
      <li>
        <span className="line line1"></span>
        <span className="line small-line"></span>
      </li>
      <li>
        <span className="line line1"></span>
        <span className="line small-line"></span>
      </li>
      <li>
        <span className="line line1"></span>
        <span className="line small-line"></span>
      </li>
      <li>
        <span className="line line1"></span>
        <span className="line small-line"></span>
      </li>
      <li>
        <span className="line line1"></span>
        <span className="line small-line"></span>
      </li>
      <li>
        <span className="line line1"></span>
        <span className="line small-line"></span>
      </li>
      
    </ul>
  );
};
 
export default ListingLoader;